import React, { useEffect } from "react";
import { defaultTokens, CSS_VAR_MAP } from "./tokens";

function get(obj, path) {
  return path.split(".").reduce((o, k) => (o ? o[k] : undefined), obj);
}

function applyTokens(tokens) {
  const root = document.documentElement;
  Object.entries(CSS_VAR_MAP).forEach(([tokPath, cssVar]) => {
    const v = get(tokens, tokPath);
    if (v !== undefined) root.style.setProperty(cssVar, v);
  });
}

/**
 * Applies design tokens as CSS variables on :root.
 * Branding (color_primary, color_secondary, color_accent, fonts) is merged on top.
 */
export function ThemeProvider({ branding, children }) {
  useEffect(() => {
    const merged = structuredClone(defaultTokens);
    if (branding) {
      if (branding.color_primary) merged.color.primary = branding.color_primary;
      if (branding.color_secondary) merged.color.secondary = branding.color_secondary;
      if (branding.color_accent) merged.color.accent = branding.color_accent;
    }
    applyTokens(merged);
  }, [branding]);
  return children;
}
